import { merge } from '../../helper';

import * as exInput from '../input';
import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        inline: false,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const src: Record<string, any> = {
        elements: [],
        list: [],
    };

    // If there is no data
    if (!defConfig.data?.length) {
        return src;
    }

    // Foreach Data
    for (let i = 0; i < defConfig.data.length; i++) {
        const itemConfig = defConfig.data[i];

        // Default Config Item
        const defConfigItem: Record<string, any> = {
            attr: {
                id: defConfig.name + '-' + (i + 1),
                name: defConfig.name,
                value: itemConfig.value ?? i + 1,
            },
            html: itemConfig.html ?? '{Radio' + (i + 1) + '}',
        };

        // Merge
        merge(defConfigItem, itemConfig);

        // --------------------------------------------------------------------

        //
        const elements: Record<string, any> = {};

        // Create element (radio)
        const elRadio = exElement.create({
            merge: defConfig,
            class: {
                new: 'form-check',
            },
        });
        elements.element = elRadio;

        // --------------------------------------------------------------------

        // Create element (input)
        const input = exInput.create({
            merge: defConfig.input,
            type: 'radio',
            class: {
                new: 'form-check-input',
            },
            attr: defConfigItem.attr,
            event: {
                change: defConfigItem.fnChange,
            },
        });
        elRadio.appendChild(input.element);
        elements.input = input.element;

        // If using checked
        if (defConfigItem.checked === true) {
            input.element.checked = true;
        }

        // If using value
        if (defConfig.value != null) {
            if (defConfig.value === defConfigItem.attr.value) {
                input.element.checked = true;
            }
        }

        // --------------------------------------------------------------------

        // If label is false, is not using label
        if (defConfig.label !== false) {
            // Create element (label)
            const elLabel = exElement.create({
                merge: defConfig.label,
                tag: 'label',
                class: {
                    new: 'form-check-label radio-label',
                },
                html: defConfigItem.html,
                container: {
                    parent: elRadio,
                },
            });
            elements.label = elLabel;

            // If using relate
            if (defConfig.label && defConfig.label.relate !== false) {
                elLabel.setAttribute('for', defConfigItem.attr.id);
            }
        }

        // --------------------------------------------------------------------

        // Settings
        settings(elements, defConfig);

        // --------------------------------------------------------------------

        // Elements Push
        src.elements.push(elRadio);

        // List Push
        src.list.push(elements);
    }

    // Return
    return src;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using inline
    if (config.inline === true) {
        elements.element.addClass('form-check-inline');
    }

    // ------------------------------------------------------------------------

    // If using checkmark
    if (config.checkmark === true) {
        // Add class (radio mark)
        elements.element.addClass('radio-mark');

        // Create element (span)
        const elSpan = exElement.create({
            merge: config.span,
            tag: 'span',
            class: {
                new: 'checkmark',
            },
        });
        elements.element.appendChild(elSpan);
    }
}

// ----------------------------------------------------------------------------

export { create };
